import React from 'react';

const FilterSideBarSkeleton = () => (
    <div className="sidebar-container_skeleton skeleton"/>
)

export default FilterSideBarSkeleton